import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../../helpers';
import { AppContextProvider } from '../../../../../Services/AppContext';
import { store } from '../../../../../store/store';
import AclContextProvider from '../../../../Acl/Components/AclContextProvider';
import WorkplaceWorkersList from './WorkplaceWorkersList';
import WorkplaceWorkersListWrapper from './WorkplaceWorkersListWrapper';
import { parseBoolean } from '../../../../../Utils/form.util';
import { ManagerContextProvider } from '../../../Services/ManagerContext';

loadDOMComponent({
	selector: 'react-workplace-workers-list',
	callback: ({ container, context }: any) => {
		const showAllWorkplaces = container.getAttribute('showAllWorkplaces');
		const workplaceId = container.getAttribute('workplaceId');
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<ManagerContextProvider
							isSuperAdmin={parseBoolean(showAllWorkplaces)}
							workplaceId={workplaceId}>
							<WorkplaceWorkersListWrapper
								showAllWorkplaces={parseBoolean(showAllWorkplaces)}
							/>
						</ManagerContextProvider>
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
